<template>
  <div class="breadcrumbs">
    <template>
      <ApolloQuery :query="query" :variables="{ id: folder._id }">
        <template v-slot="{ result: { loading, error, data } }">
          <!-- Loading -->
          <div v-if="loading" class="loading apollo">
            <BreadcrumbsChild :folder="folder" :first="true" />
          </div>

          <!-- Result -->
          <div
            v-else-if="data && data.findFolderByID"
            class="breadcrumbs__result apollo"
          >
            <BreadcrumbsChild :folder="data.findFolderByID" :first="true" />
          </div>
        </template>
      </ApolloQuery>
    </template>
  </div>
</template>

<script>
/** Query */
import GET_BREADCRUMBS from '@/graphql/GetBreadcrumbs.gql'

/** Components */
import BreadcrumbsChild from '@/components/BreadcrumbsChild.vue'

export default {
  components: {
    BreadcrumbsChild,
  },

  props: {
    folder: {
      type: Object,
      required: true,
    },
  },

  computed: {
    query() {
      return GET_BREADCRUMBS
    },

    // breadcrumbs(result = []) {
    //   for (const item of this.data.findFolderByID) {
    //     console.log(result, item)
    //   }

    //   return result
    // },
  },

  methods: {},
}
</script>

<style lang="scss" scoped></style>
